/**
 * 背景動画の遅延読み込み（ヨコモ独自・#525）。
 *
 * `<source data-video-source>` を持つ `<video>` を、要素が画面に近づいたときだけ読み込む。
 * Horizon の `video-background-component` は表示位置に関係なく即 `load()` するため、
 * ファーストビュー外の動画もページ表示直後に全量ダウンロードされていた。
 *
 * 画面の少し手前（ROOT_MARGIN）で読み込みを始め、一度読み込んだら監視をやめる。
 * prefers-reduced-motion: reduce のときは動画を表示しない（stylesheet 側）ので、読み込み自体を行わない。
 */
const ROOT_MARGIN = '200px 0px';

class BackgroundVideoLazyYokomo extends HTMLElement {
  #observer = null;

  connectedCallback() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    this.#observer = new IntersectionObserver(
      (entries) => {
        if (!entries.some((entry) => entry.isIntersecting)) return;

        this.#disconnect();
        this.#load();
      },
      { rootMargin: ROOT_MARGIN }
    );
    this.#observer.observe(this);
  }

  disconnectedCallback() {
    this.#disconnect();
  }

  #disconnect() {
    this.#observer?.disconnect();
    this.#observer = null;
  }

  #load() {
    const video = this.querySelector('video');
    if (!video) return;

    for (const source of video.querySelectorAll('source[data-video-source]')) {
      source.setAttribute('src', source.dataset.videoSource);
    }

    video.load();
  }
}

if (!customElements.get('background-video-lazy-yokomo')) {
  customElements.define('background-video-lazy-yokomo', BackgroundVideoLazyYokomo);
}
